<div class="snack-container box-{{ getSnackBarDesign.type }}">
  <div class="snack-container-message">
    <div class="{{ getSnackBarDesign.iconDesign }} icon-center">
      <mat-icon>{{ getSnackBarDesign.icon }}</mat-icon>
    </div>&nbsp; &nbsp;
    <div class="{{ getSnackBarDesign.messageAlign }}">
      <span>{{ data.message }}</span>
    </div>
  </div>
  <div class="snack-container-icon icon-center">
    <mat-icon (click)="closeSnackbar()">close</mat-icon>
  </div>
</div>
